<template>
<div>
    <v-text-field :label="label" :error-messages="emailValidationError" :rules="emailRules" :value="value" @input="emailInput" @change="validateEmail" autocomplete="off" :hide-details="hideDetails" :prepend-icon="icon">
        <template v-slot:append>
            <v-progress-circular v-if="status == 'Checking'" size="20" width="2" color="info" indeterminate />
            <v-icon v-if="status == ''" color="green">check_circle</v-icon>
        </template>
    </v-text-field>
    <v-text-field ref="confirmation" v-if="confirmationVisible" v-model="confirmation" label="Confirm Email" autocomplete="off" :hide-details="hideDetails" :prepend-icon="confirmationIcon" />
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import CloudHelpers from '../helpers/CloudHelpers'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'


export default {
    data() {
        return {
            status: 'Empty',
            confirmation: '',
            emailRules: [
                v => (!v || StringHelpers.isEmail(v)) || 'Enter a valid email'
            ],
        }
    },
    
    props: {
        value: String,
        label: {
            type: String,
            default: 'Email'
        },
        hideDetails: [Boolean, String],
        icon: String,
    },

    computed: {
        valid() {
            return this.status == '' || this.status == 'Empty' || this.value == this.confirmation
        },

        confirmationIcon() {
            if(this.icon)
                return 'arrow_right'
            else
                return ''
        },

        confirmationVisible() {
            return this.status != 'Enter a valid email' && this.status != 'Checking' && this.status != '' && this.status != 'Empty' && this.status != 'Invalid email format'
        },

        emailValidationError() {

            if(this.valid)
                return ''
                
            if(this.status == 'Checking')
                return 'Checking...'

            if(this.status == 'Empty') {
                if(StringHelpers.isEmail(this.value) || this.value.length == 0 )
                    return ''
                else
                    return 'Enter a valid email'
            }
            
            return this.status + (this.status != 'Invalid email format' ? '. Please confirm below' : '') 
 
        },

    },

    methods: {

        emailInput(newVal) {
            this.$emit('input', newVal)
        },

        async validateEmail(email) {
            if(!email)
                return

            this.status = 'Checking'
            this.status = await CloudHelpers.validateEmail(email)
            console.log('validating email returned', this.status)

            if(this.status == 'Unable to verify')
                Utilities.focus(this, 'confirmation', true)

        },

        validate() {
            return this.valid
        }
    },

    watch: {
        'value': {
            handler: function(newVal) {
                this.status = 'Empty'
                this.confirmation = ''
            }
        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// EmailBox.vue?a37e3620